<template>
  <!--  en gros tu vois on a pour chaque plante un tablmeau de photo -->
  <div class="response-container">
    <button
      v-for="(response, key) in finalResponse"
      :key="key"
      class="q2"
      @click="choosePlant(key)"
    >
      {{ game === 2 ? response.nom : "" }}
      <img
        :src="'../img/data/' + response.image[0]"
        class="iq"
        v-if="game === 1"
      />
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "responses",
  mounted() {
    setTimeout(() => {
      this.filtreQuestionsDiffOfFamily();
    }, 50);
  },
  props: {
    goodResponse: Object,
  },
  computed: {
    ...mapGetters({
      plants: "plants",
      game: "game",
    }),
  },
  data() {
    return {
      fakeResponse: [], //liste des plantes mélangés
      finalResponse: [], //liste des réponses proposée
    };
  },
  methods: {
    // récupère la liste en dehors de la famille selectionnée et mélange la liste
    filtreQuestionsDiffOfFamily() {
      let questionfilter = this.plants.filter((question) => {
        return question.famille != this.family;
      });
      this.fakeResponse = questionfilter.sort(() => Math.random() - 0.5);
      this.responseRenderGenerator();
    },

    // créé une liste réduite de 4 noms random et remplace une au hasard par la bonne réponse
    responseRenderGenerator() {
      for (let index = 0; index < 4; index++) {
        const chosenFakeResponse = this.fakeResponse[
          this.getRandomInt(this.fakeResponse.length)
        ];
        if (!this.finalResponse.includes(chosenFakeResponse)) {
          this.finalResponse.push(chosenFakeResponse);
        } else {
          index--;
        }
      } //fin du for
      this.finalResponse[this.getRandomInt(4)] = this.goodResponse;
      for (const key in this.finalResponse) {
        this.finalResponse[key].image = [
          this.finalResponse[key].image[
            this.getRandomInt(this.finalResponse[key].image.length)
          ],
        ];
      }
    },
    //Retourne un entier au hasard
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    choosePlant(response) {
      this.$emit("getResponse", this.finalResponse[response]);
    },
  },
};
</script>
